__turbopack_context__.v({
  "colorButton": "KMmLCa_colorButton",
  "container": "KMmLCa_container",
  "input": "KMmLCa_input",
  "label": "KMmLCa_label",
  "pickerContainer": "KMmLCa_pickerContainer",
});
